/** 隐私政策（简体中文正文在此维护，与站内 /privacy 一致） */
export const privacyTitle = '隐私政策';

export const privacyBody = 
`第 1 章 总则
（目的）
第 1 条 本规则旨在对 Japan DX 株式会社（以下简称 “本公司”）在本会议中处理个人信息等相关基本事项作出规定。在遵守本规则的前提下，可就个人信息等的处理另行制定实施细则。但本会议工作人员个人信息的处理，依照另行规定执行。
（定义）
第 2 条 本规则中用语定义如下：
（1）个人信息
指与存活个人相关的信息，可通过该信息所含姓名、出生日期及其他描述等识别特定个人（包含可轻易与其他信息进行对照，进而识别特定个人的信息）。
（2）个人信息数据库等
指包含个人信息的信息集合，且符合下列情形：
① 利用计算机对特定个人信息进行系统化构建，实现可检索的信息集合；
② 除上述①所列情形外，对信息集合所含个人信息按一定规则整理，实现特定个人信息可便捷检索的系统化信息集合，且配备目录、索引等便于检索的相关内容。
（3）个人数据
指构成个人信息数据库等的个人信息。
（4）持有个人数据
指本会议拥有对其开展披露、内容更正、追加或删除、停止使用、删除及停止向第三方提供权限的全部个人数据，但下列情形除外：
① 因披露该个人数据是否存在，会损害公共利益及其他利益的；
② 计划在 6 个月内予以删除的。
（5）本人
指通过个人信息可被识别的特定个人。
（个人信息保护总负责人等）
第 3 条
（1） 本公司设置个人信息保护总负责人，统筹负责个人信息保护相关措施的业务工作，由个人信息保护总负责人履行相关职责。
第 2 章 个人信息
（获取原则）
第 4 条
（1） 个人信息应在经营及业务所需范围内获取，事先明确使用目的，并在实现该目的所需限度内进行获取。
（2） 原则上不获取、使用或提供包含下列内容的个人信息：
与思想、信念及宗教相关的事项；
与人种、民族、门第、籍贯（都道府县除外）及其他可能引发社会歧视的事项。
（正当获取）
第 5 条 禁止以欺诈及其他不正当手段获取个人信息。
（使用目的的公布或通知）
第 6 条
（1） 获取个人信息时，原则上通过官网、机关刊物等渠道公布下列事项：
使用目的；
个人数据向第三方提供的相关事项；
个人数据共同使用的相关事项。
（2） 未公布使用目的的，获取个人信息时，应以书面或口头形式向本人告知使用目的。但下列情形除外：
告知或公布使用目的可能损害本人或第三方的生命、身体、财产及其他合法权益的；
告知或公布使用目的可能损害本会议权利或正当利益的；
需配合国家机关或地方公共团体履行法定事务，且告知或公布使用目的会妨碍该事务执行的；
从获取情形可判断使用目的显而易见的。
（3） 本条第 1 项所列各项内容的制定与修改，除轻微修正外，须经个人信息保护总负责人批准。
第 3 章 个人数据
（确保准确性）
第 7 条 应尽力保证个人数据内容准确、最新。
（保存期限）
第 8 条 应尽力为个人数据设定在实现使用目的所需范围内的保存期限，保存期限届满或达成使用目的后，及时予以删除。
（安全管理措施）
第 9 条
（1） 为防止个人数据泄露、灭失或损毁（以下简称 “泄露等”），采取下列措施：
技术管理措施：防范非法访问；
人员管理措施：向工作人员充分宣导，防止个人信息泄露等情况发生；必要时签订保密协议。
（2） 工作人员须尽力提前防范，避免个人信息泄露等情况发生。
（受托方监管）
第 10 条 将个人数据处理业务委托外部机构的，应与受托方就保密事项、再委托事项及前条规定的安全管理措施等内容签订合同。
（向第三方提供的限制）
第 11 条
（1） 向第三方提供个人数据的，应事先通过书面或口头形式取得本人明确同意。但下列情形除外：
依据法律法规规定的；
为保护人的生命、身体或财产所必需，且难以取得本人同意的；
为提升公共卫生水平或促进儿童健康成长尤为必需，且难以取得本人同意的；
需配合国家机关、地方公共团体或其受托方履行法定事务，且取得本人同意会妨碍该事务执行的；
在实现使用目的所需范围内委托处理个人数据的；
已按本条第 1 项第 2 目规定，公布《个人信息保护法》第 23 条第 2 项所列事项的；
已按本条第 1 项第 3 目规定，公布《个人信息保护法》第 23 条第 4 项第 3 目所列事项的。
（2） 向第三方提供个人数据的，应事先向个人信息事务管理员报备，并经个人信息保护总负责人批准。但符合本条第 1 项第 5 目情形、已采取本条第 1 项第 6 目或第 7 目规定措施，以及紧急情况除外。
第 4 章 持有个人数据
（持有个人数据相关事项的公布等）
第 12 条
（1） 本人请求告知可识别其本人的持有个人数据的使用目的的，应及时告知。但下列情形除外：
持有个人数据的使用目的显而易见的；
符合第 6 条第 2 项第 1 目至第 3 目规定情形的。
（2） 依据前款规定决定不予告知本人所请求的持有个人数据使用目的的，应及时将该决定告知本人。
（披露）
第 13 条
（1） 本人请求披露可识别其本人的持有个人数据（不含可识别本人的持有个人数据不存在时的告知情形，下同）的，应通过书面或本人同意的方式及时披露。但下列情形除外：
可能损害本人或第三方的生命、身体、财产及其他合法权益的；
可能严重妨碍本会议业务正常开展的；
违反其他法律法规规定的。
（2） 依据前款规定决定对本人请求的持有个人数据全部或部分不予披露的，应及时将该决定及依据条款告知本人。
（3） 其他法律法规规定需以相当于本条第 1 项正文所列方式，向本人披露可识别其本人的全部或部分持有个人数据的，不适用本条第 1 项规定。
（更正等）
第 14 条
（1） 本人以可识别其本人的持有个人数据内容与事实不符为由，请求对该持有个人数据内容进行更正、追加或删除（以下简称 “更正等”）的，应在实现使用目的所需范围内，及时开展事实确认等必要调查，并根据调查结果对持有个人数据内容进行更正等处理。
（2） 依据前款规定进行更正等处理，或决定不予处理的，应及时将相关情况（进行更正等处理的，一并告知处理内容）告知本人。
（停止使用等）
第 15 条
（1） 本人以违反《个人信息保护法》第 16 条（使用目的限制）或第 17 条（正当获取）规定为由，请求停止使用或删除持有个人数据，经查证请求理由成立的，应在必要限度内及时停止使用该持有数据等；难以执行的，采取必要的替代措施保护本人合法权益。
（2） 本人以违反《个人信息保护法》第 23 条（向第三方提供的限制）规定为由，请求停止向第三方提供持有个人数据，经查证请求理由成立的，应在必要限度内及时停止向第三方提供该持有数据；难以执行的，采取必要的替代措施保护本人合法权益。
（3） 采取前两项所列各项措施，或决定不予采取措施的，应及时将相关情况告知本人。
（理由说明）
第 16 条 依据第 12 条第 2 项、第 13 条第 2 项、第 14 条第 2 项、前条第 3 项规定，就本人请求的全部或部分措施，告知不予采取或采取不同措施的，应尽力向本人说明理由。
第 5 章 泄露等情况的应对
（发生泄露等情况时的应对）
第 17 条
（1） 工作人员发现泄露等情况的，须立即以口头形式向个人信息事务管理员报告。
（2） 个人信息事务管理员应迅速调查核实相关事实，防范次生灾害、避免类似事件再次发生，并尽力公布相关事实情况；即便调查核实事实需要耗时，也应从防范次生灾害角度公布泄露事实，尽力挽回社会信任。
（全文完）
`;
